import React from 'react'
import { Link } from 'react-router-dom'
import { useState } from 'react';
import img2 from "../../../assets/images/home_page_4/deals/02.png"
import img3 from "../../../assets/images/home_page_4/deals/03.png"
import img1 from "../../../assets/images/home_page_4/deals/01.png"
import img4 from "../../../assets/images/home_page_4/deals/04.png"
import img6 from "../../../assets/images/home_page_4/deals/06.png"
import img5 from "../../../assets/images/home_page_4/deals/05.png"


const DealProduct = () => {

    const [ActiveTab, setActiveTab] = useState('Latest Products');
    const [showModal, setShowModal] = useState(false);
    const toggleModal = () => setShowModal(!showModal);

    const handleTabchange = (tab) => {
        setActiveTab(tab);
    }


    return (
        <div>
            <section id="deals-product" className="deals-product-main-block">
                <div className="container">
                    <div className="deals-product-border">
                        <div className="row">
                            <div className="col-lg-4 col-md-5">
                                <div className="section">
                                    <h3 className="section-heading-first">Deals Of The Day</h3>
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-7">
                                <ul className="nav nav-pills float-lg-end float-start"
                                    id="pills-tab"
                                    role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <Link className={`nav-link ${ActiveTab === "Latest Products" ? "active" : ""}`}
                                            id="pills-tab1-tab"
                                            onClick={() => handleTabchange("Latest Products")}
                                            data-bs-toggle="pill"
                                            to="#pills-tab1" role="tab"
                                            aria-controls="pills-tab1"
                                            aria-selected="true">Latest Products</Link>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <Link className={`nav-link ${ActiveTab === "Top Rating" ? "active" : ""}`}
                                            id="pills-tab2-tab"
                                            onClick={() => handleTabchange("Top Rating")}
                                            data-bs-toggle="pill"
                                            to="#pills-tab2" role="tab"
                                            aria-controls="pills-tab2"
                                            aria-selected="false">Top Rating</Link>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <Link className={`nav-link ${ActiveTab === "Best Selling" ? "active" : ""}`}
                                            id="pills-tab3-tab"
                                            onClick={() => handleTabchange("Best Selling")}
                                            data-bs-toggle="pill"
                                            to="#pills-tab3" role="tab"
                                            aria-controls="pills-tab3"
                                            aria-selected="false">Best Selling</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="tab-content" id="pills-tabContent">
                        <div className={`tab-pane fade ${ActiveTab === 'Latest Products' ? 'show active' : ''}`}

                            id="pills-tab1"
                            role="tabpanel"

                            aria-labelledby="pills-tab1-tab"
                           >
                            <div className="row">
                                <div className="col-lg-2 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link to="/ShopDetails" title=""><img src={img2} className="img-fluid" alt="" /></Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading"><Link to="/ShopDetails" title="">Sony A7 III Mirrorless Camera with 4K Video</Link></h6>
                                            <div className="price">$159.77 <s>$</s><s>159.77</s></div>
                                            <div className="deals-product-btn">
                                                <Link to="" className="btn btn-primary" title=""><i className="flaticon-shopping-cart"></i>Add to cart</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link to="/ShopDetails" title=""><img src={img3} className="img-fluid" alt="" /></Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading"><Link to="/ShopDetails" title="">Sony A7 III Mirrorless Camera with 4K Video</Link></h6>
                                            <div className="price">$159.77 <s>$</s><s>159.77</s></div>
                                            <div className="deals-product-btn">
                                                <Link to="" className="btn btn-primary" title=""><i className="flaticon-shopping-cart"></i>Add to cart</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link to="/ShopDetails" title=""><img src={img1} className="img-fluid" alt="" /></Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading"><Link to="/ShopDetails" title="">Sony A7 III Mirrorless Camera with 4K Video</Link></h6>
                                            <div className="price">$159.77 <s>$</s><s>159.77</s></div>
                                            <div className="deals-product-btn">
                                                <Link to="" className="btn btn-primary" title=""><i className="flaticon-shopping-cart"></i>Add to cart</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link to="/ShopDetails" title=""><img src={img6} className="img-fluid" alt="" /></Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading"><Link to="/ShopDetails" title="">Sony A7 III Mirrorless Camera with 4K Video</Link></h6>
                                            <div className="price">$159.77 <s>$</s><s>159.77</s></div>
                                            <div className="deals-product-btn">
                                                <Link to="" className="btn btn-primary" title=""><i className="flaticon-shopping-cart"></i>Add to cart</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link to="/ShopDetails" title=""><img src={img4} className="img-fluid" alt="" /></Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading"><Link to="/ShopDetails" title="">Sony A7 III Mirrorless Camera with 4K Video</Link></h6>
                                            <div className="price">$159.77 <s>$</s><s>159.77</s></div>
                                            <div className="deals-product-btn">
                                                <Link to="" className="btn btn-primary" title=""><i className="flaticon-shopping-cart"></i>Add to cart</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link to="/ShopDetails" title=""><img src={img5} className="img-fluid" alt="" /></Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading"><Link to="/ShopDetails" title="">Sony A7 III Mirrorless Camera with 4K Video</Link></h6>
                                            <div className="price">$159.77 <s>$</s><s>159.77</s></div>
                                            <div className="deals-product-btn">
                                                <Link to="" className="btn btn-primary" title=""><i className="flaticon-shopping-cart"></i>Add to cart</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`tab-pane fade ${ActiveTab === 'Top Rating' ? 'show active' : ''}`}
                            id="pills-tab2"
                            onClick={toggleModal}
                            role="tabpanel"
                            aria-labelledby="pills-tab2-tab"
                            >
                            <div className="row">
                                <div className="col-lg-2">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link to="/ShopDetails" title=""><img src={img5} className="img-fluid" alt="" /></Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading"><Link to="/ShopDetails" title="">Sony A7 III Mirrorless Camera with 4K Video</Link></h6>
                                            <div className="price">$159.77 <s>$</s><s>159.77</s></div>
                                            <div className="deals-product-btn">
                                                <Link to="" className="btn btn-primary" title=""><i className="flaticon-shopping-cart"></i>Add to cart</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link to="/ShopDetails" title=""><img src={img4} className="img-fluid" alt="" /></Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading"><Link to="/ShopDetails" title="">Sony A7 III Mirrorless Camera with 4K Video</Link></h6>
                                            <div className="price">$159.77 <s>$</s><s>159.77</s></div>
                                            <div className="deals-product-btn">
                                                <Link to="" className="btn btn-primary" title=""><i className="flaticon-shopping-cart"></i>Add to cart</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link to="/ShopDetails" title=""><img src={img6} className="img-fluid" alt="" /></Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading"><Link to="/ShopDetails" title="">Sony A7 III Mirrorless Camera with 4K Video</Link></h6>
                                            <div className="price">$159.77 <s>$</s><s>159.77</s></div>
                                            <div className="deals-product-btn">
                                                <Link to="" className="btn btn-primary" title=""><i className="flaticon-shopping-cart"></i>Add to cart</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link to="/ShopDetails" title=""><img src={img1} className="img-fluid" alt="" /></Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading"><Link to="/ShopDetails" title="">Sony A7 III Mirrorless Camera with 4K Video</Link></h6>
                                            <div className="price">$159.77 <s>$</s><s>159.77</s></div>
                                            <div className="deals-product-btn">
                                                <Link to="" className="btn btn-primary" title=""><i className="flaticon-shopping-cart"></i>Add to cart</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link to="/ShopDetails" title=""><img src={img3} className="img-fluid" alt="" /></Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading"><Link to="/ShopDetails" title="">Sony A7 III Mirrorless Camera with 4K Video</Link></h6>
                                            <div className="price">$159.77 <s>$</s><s>159.77</s></div>
                                            <div className="deals-product-btn">
                                                <Link to="" className="btn btn-primary" title=""><i className="flaticon-shopping-cart"></i>Add to cart</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link to="/ShopDetails" title=""><img src={img2} className="img-fluid" alt="" /></Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading"><Link to="/ShopDetails" title="">Sony A7 III Mirrorless Camera with 4K Video</Link></h6>
                                            <div className="price">$159.77 <s>$</s><s>159.77</s></div>
                                            <div className="deals-product-btn">
                                                <Link to="" className="btn btn-primary" title=""><i className="flaticon-shopping-cart"></i>Add to cart</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`tab-pane fade ${ActiveTab === 'Best Selling' ? 'show active' : ''}`}
                            id="pills-tab3"
                            role="tabpanel" aria-labelledby="pills-tab3-tab" >
                            <div className="row">
                                <div className="col-lg-2">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link to="/ShopDetails" title=""><img src={img1} className="img-fluid" alt="" /></Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading"><Link to="/ShopDetails" title="">Sony A7 III Mirrorless Camera with 4K Video</Link></h6>
                                            <div className="price">$159.77 <s>$</s><s>159.77</s></div>
                                            <div className="deals-product-btn">
                                                <Link to="" className="btn btn-primary" title=""><i className="flaticon-shopping-cart"></i>Add to cart</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link to="/ShopDetails" title=""><img src={img3} className="img-fluid" alt="" /></Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading"><Link to="/ShopDetails" title="">Sony A7 III Mirrorless Camera with 4K Video</Link></h6>
                                            <div className="price">$159.77 <s>$</s><s>159.77</s></div>
                                            <div className="deals-product-btn">
                                                <Link to="" className="btn btn-primary" title=""><i className="flaticon-shopping-cart"></i>Add to cart</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link to="/ShopDetails" title=""><img src={img5} className="img-fluid" alt="" /></Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading"><Link to="/ShopDetails" title="">Sony A7 III Mirrorless Camera with 4K Video</Link></h6>
                                            <div className="price">$159.77 <s>$</s><s>159.77</s></div>
                                            <div className="deals-product-btn">
                                                <Link to="" className="btn btn-primary" title=""><i className="flaticon-shopping-cart"></i>Add to cart</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link to="/ShopDetails" title=""><img src={img6} className="img-fluid" alt="" /></Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading"><Link to="/ShopDetails" title="">Sony A7 III Mirrorless Camera with 4K Video</Link></h6>
                                            <div className="price">$159.77 <s>$</s><s>159.77</s></div>
                                            <div className="deals-product-btn">
                                                <Link to="" className="btn btn-primary" title=""><i className="flaticon-shopping-cart"></i>Add to cart</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link to="/ShopDetails" title=""><img src={img2} className="img-fluid" alt="" /></Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading"><Link to="/ShopDetails" title="">Sony A7 III Mirrorless Camera with 4K Video</Link></h6>
                                            <div className="price">$159.77 <s>$</s><s>159.77</s></div>
                                            <div className="deals-product-btn">
                                                <Link to="" className="btn btn-primary" title=""><i className="flaticon-shopping-cart"></i>Add to cart</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link to="/ShopDetails" title=""><img src={img4} className="img-fluid" alt="" /></Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading"><Link to="/ShopDetails" title="">Sony A7 III Mirrorless Camera with 4K Video</Link></h6>
                                            <div className="price">$159.77 <s>$</s><s>159.77</s></div>
                                            <div className="deals-product-btn">
                                                <Link to="" className="btn btn-primary" title=""><i className="flaticon-shopping-cart"></i>Add to cart</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default DealProduct